import React, { ReactElement } from "react";
import { Grid, Switch } from "@mui/material";
import { DEFAULT_FIELD_WIDTH, DEFAULT_LABEL_WIDTH } from "modules/topics/styles/constants";
import HoverText from "modules/documents/components/action-buttons/hoverText";
import { Audience, BasicAudience } from "modules/audiences";
import AudienceSearchAndChips from "./audienceSearchAndChips";

interface ComponentProps {
    label: string;
    hoverText: string;
    defaultChipText: string | ReactElement;
    audiences: Audience[];
    selected: BasicAudience[];
    toggleStatus: boolean;
    setSelected: (selected: BasicAudience[]) => void;
    onSwitch: (state: boolean) => void;
}

const TopicDetailSwitch: React.FunctionComponent<ComponentProps> = (props) => {
    const [showAudiences, setShowAudiences] = React.useState(props.toggleStatus);

    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setShowAudiences(!showAudiences);
        props.onSwitch(event.target.checked);
    };

    const onSelectAudiences = (audiences: BasicAudience[]) => props.setSelected(audiences);

    return (
        <React.Fragment>
            <Grid item xs={DEFAULT_LABEL_WIDTH}>
                <HoverText label={props.label} labelContainerClassName="detail-label">
                    {props.hoverText}
                </HoverText>
            </Grid>

            <Grid item xs={DEFAULT_FIELD_WIDTH} sx={{display: "flex"}}>

                <div>
                    <Switch
                        checked={showAudiences}
                        onChange={handleChange}
                    />
                </div>

                {
                    showAudiences && 
                    <AudienceSearchAndChips
                        audiences={props.audiences}
                        selected={props.selected}
                        onSelect={onSelectAudiences}
                        anchorEl={anchorEl}
                        setAnchorEl={setAnchorEl}
                        emptyChipContents={props.defaultChipText}
                    />
                }
            </Grid>
        </React.Fragment>
    );
};

export default TopicDetailSwitch;